/**
 * HELP-RENDER.UTILS
 * Text of a guide written in Strapi, ready to be displayed : cleaned, then the markers of the account replaced and the
 * icons written as SVG (shared by the window of the guide and by the copy of a section)
 */
import { sanitizeHelpHtml } from "@/utils/help-article-html.utils"
import { removeHelpPlaceholders } from "@/utils/help-article.utils"
import { HelpAccountColors, injectHelpIcons } from "@/utils/help-icons-render.utils"
import { HelpValues, replaceHelpNoteTokens, replaceHelpValueTokens } from "@/utils/help-values.utils"

export function prepareHelpHtml(text: string, values: HelpValues, accountColors: HelpAccountColors): string {
  return injectHelpIcons(
    replaceHelpNoteTokens(replaceHelpValueTokens(sanitizeHelpHtml(removeHelpPlaceholders(text)), values)),
    accountColors
  )
}
